import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from '@material-ui/core';
import ZonasKm from './ZonasKm';

const ZonasKmIndex = () => {
    const history = useHistory();

    return (
        <div className="w-full p-4 md:p-6">
            <div className="flex justify-between items-center mb-6">
                <div>
                    <h1 className="text-2xl font-bold text-gray-900 tracking-tight">Zonas KM y Horas de Entrega</h1>
                    <p className="text-sm text-gray-500 mt-1">Configuración de rangos de distancia en kilómetros y tiempos estimados de entrega (ETA).</p>
                </div>
                <Button
                    className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded-full shadow-md"
                    variant="contained"
                    color="primary"
                    onClick={() => history.push(`/Catalogo/ZonaKm`)}
                >
                    + Nueva Zona KM
                </Button>
            </div>

            <div className="mb-6 p-4 bg-blue-50 border border-blue-200 rounded-lg text-sm text-blue-900 flex items-start gap-3">
                <span className="text-xl">ℹ️</span>
                <div>
                    <span className="font-bold block">Regla de estimación de entrega (ETA):</span>
                    <p className="mt-0.5 text-xs text-blue-800 leading-relaxed">
                        Al salir a reparto (Estatus 8), el sistema calcula la distancia lineal entre la sucursal origen y la colonia destino. 
                        Ubica la zona correspondiente según el rango exacto de kilómetros (<strong>desde KM hasta KM</strong>) y suma las horas configuradas a la hora de salida. 
                        Si la guía tiene Cita EAD programada antes del tiempo calculado, la estimación se topará a la cita.
                    </p>
                </div>
            </div>

            <ZonasKm />
        </div>
    );
};

export default ZonasKmIndex;
